export const FETCHING_JURIDICTIONAL_BREAKDOWN = "FETCHING_JURIDICTIONAL_BREAKDOWN";
export const FETCH_JURISDICTIONAL_BREAKDOWN_SUCCESS = "FETCH_JURIDICTIONAL_BREAKDOWN";
export const FETCH_JURISDICTIONAL_BREAKDOWN_FAILED = "FETCH_JURIDICTIONAL_BREAKDOWN_FAILED";
export const RESET_JURISDICTIONAL_BREAKDOWN = "RESET_JURISDICTIONAL_BREAKDOWN";


// WEBPACK FOOTER //
// ./src/redux/invoiceDetail/InvoiceDetailConstants.js